export default "<ion-app>\n  <ion-router-outlet *ngIf=\"assetsFetched\"></ion-router-outlet>\n</ion-app>\n";